import { useCallback } from 'react';
import useU2000AxiosAuthenticated from '../u2000Core/axios/U2000UseAxiosAuthenticated';
import {
  useU2000SearchHandlers,
  type U2000SearchHandlersParams,
  type U2000SearchHandlersReturn,
} from '../u2000Core/hooks/handler/U2000UseSearchHandlers';
import { doSearch, type U3139MinutesSearchRow } from '../u3139Minutes/U3139Service';

export { U3121_PROJECT_MINUTES_PAGE_SIZE, u3121BuildProjectMinutesSearchParameter } from './tools/u3121ProjectMinutesSearch';

/** Recherche minutes U3139 depuis la fiche projet U3121 (ne pas appeler `doSearch` depuis le composant). */
export function useU3121ProjectMinutesSearchHandlers(
  params: Omit<U2000SearchHandlersParams<U3139MinutesSearchRow>, 'doSearchFn'>,
): U2000SearchHandlersReturn {
  const axios = useU2000AxiosAuthenticated();
  const doSearchFn = useCallback(
    (searchPayload: Parameters<typeof doSearch>[1]) => doSearch(axios, searchPayload),
    [axios],
  );
  return useU2000SearchHandlers<U3139MinutesSearchRow>({ ...params, doSearchFn });
}
